"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARD_PADDING = void 0;
exports.default = VisualCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const yet_another_react_lightbox_1 = __importDefault(require("yet-another-react-lightbox"));
const youtube_1 = __importDefault(require("react-player/youtube"));
const fullscreen_1 = __importDefault(require("yet-another-react-lightbox/plugins/fullscreen"));
const zoom_1 = __importDefault(require("yet-another-react-lightbox/plugins/zoom"));
const useDevice_1 = require("../../hooks/useDevice");
const AppButton_1 = require("../AppButton");
const Skeleton_1 = __importDefault(require("../Skeleton"));
const colors_1 = require("../../common/colors");
const spacing_1 = require("../../common/spacing");
const borders_1 = require("../../common/borders");
require("yet-another-react-lightbox/styles.css");
exports.CARD_PADDING = spacing_1.Spacing.SPACING_MD;
function VisualCard({ uri, alt, loading, width, height, aspectRatio, document, media = 'image', }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const [isViewingImage, setIsViewingImage] = (0, react_1.useState)(false);
    const handleImagePress = (0, react_1.useCallback)(() => {
        setIsViewingImage(true);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: loading ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Skeleton_1.default, { style: {
                                width,
                                height,
                                aspectRatio,
                                borderRadius: borders_1.Borders.RADIUS_MD,
                            } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonsContainer, children: document && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppButton_1.UploadDocumentImageButton, { document: document }), (0, jsx_runtime_1.jsx)(AppButton_1.RegenerateDocumentImageButton, { document: document })] })) })] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: media === 'image' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleImagePress, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { source: { uri }, alt: alt, style: [
                                        styles.image,
                                        isMobileScreen && styles.imageMobile,
                                        { width, height, aspectRatio }
                                    ] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonsContainer, children: document && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppButton_1.UploadDocumentImageButton, { document: document }), (0, jsx_runtime_1.jsx)(AppButton_1.RegenerateDocumentImageButton, { document: document })] })) })] })) : ((0, jsx_runtime_1.jsx)(youtube_1.default, { url: uri, controls: true, width: width ?? "100%", height: height ?? "100%", style: { aspectRatio } })) })) }), (0, jsx_runtime_1.jsx)(yet_another_react_lightbox_1.default, { slides: [{ src: uri }], open: isViewingImage, close: () => setIsViewingImage(false), carousel: { finite: true }, zoom: { maxZoomPixelRatio: 10 }, render: {
                    buttonPrev: () => null,
                    buttonNext: () => null,
                }, plugins: [fullscreen_1.default, zoom_1.default] })] }));
}
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: colors_1.Colors.DARK_600,
        justifyContent: 'center',
        alignContent: 'center',
        padding: exports.CARD_PADDING,
        borderRadius: borders_1.Borders.RADIUS_MD,
        resizeMode: "contain"
    },
    image: {
        borderRadius: borders_1.Borders.RADIUS_MD,
    },
    imageMobile: {
        borderRadius: 0,
    },
    buttonsContainer: {
        position: 'absolute',
        top: 13.5,
        right: 12,
        gap: 8,
        flexDirection: 'row',
    },
});
